var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 79C5 79 3 83 3 85.5V135C3 162 28.8333 164.167 38.5 164C64.6667 164.5 120.9 165.2 136.5 164C152.1 162.8 164.5 150 164.5 135V87.5C164.5 81.9 161 79 156 79C110.667 79.1667 18.5133 79 12.5 79Z",
    fill: "url(#paint0_linear_189_997)",
    fillOpacity: 0.46
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 56.5L46.0001 19C41.5001 20 29.5001 22.7 17.5001 25.5C5.50007 28.3 -2.5 43.5 1.50008 56C5.00001 63.5 8.00008 63 12.5001 62L39.0001 56.5Z",
    fill: "url(#paint1_linear_189_997)",
    fillOpacity: 0.84
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 6.49999L65.5 14.5L58 52.5L96 44.5L103 6.49999Z",
    fill: "url(#paint2_linear_189_997)",
    fillOpacity: 0.84
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115 40.5L122.5 2.5C138.5 -4.3 152 7.49999 156.5 14.5C158 17 158.5 17.5 160 22C162.12 28.3611 156.833 31.3333 154 32L115 40.5Z",
    fill: "url(#paint3_linear_189_997)",
    fillOpacity: 0.84
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_997",
    x1: 311,
    y1: 10,
    x2: -3.99999,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_189_997",
    x1: 248.5,
    y1: -7.5,
    x2: -8.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C36EFF",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_189_997",
    x1: 248.5,
    y1: -7.5,
    x2: -8.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C36EFF",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_189_997",
    x1: 248.5,
    y1: -7.5,
    x2: -8.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C36EFF",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVid);
export default __webpack_public_path__ + "static/media/vid.255f25c07258d337097becd474a072c1.svg";
export { ForwardRef as ReactComponent };